<div>
	<div *ngFor="let group of groups; trackByItem" class="controlGroup">
		<div class="groupHeader">
			<label class="groupLabel">{{ group }}</label>
		</div>
		<mat-table class="table" [dataSource]="this.getFieldsByGroup(group)">
			<ng-container matColumnDef="FieldName">
				<mat-header-cell *matHeaderCellDef>
					label
				</mat-header-cell>
				<mat-cell *matCellDef="let field">
					{{ field.FieldName }}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="EditColumn">
				<mat-header-cell *matHeaderCellDef>
					label for col2
				</mat-header-cell>
				<mat-cell class="controlRow" *matCellDef="let field">
					<div class="controlWidth" *ngIf="!field.ListOfValues || field.ListOfValues.length === 0">
						<input type="text" name="fieldValue_{{field.id}" class="form-control" [(ngModel)]="field.FieldValue"
							(change)="fieldChanged(field)" maxlength="50" [disabled]="readOnly" />
					</div>
					<div class="no-border-radius controlWidth"
						*ngIf="field.ListOfValues && field.ListOfValues.length !== 0 && field.LimitToList === false">
						<mat-form-field [style.width.%]="100">
							<input matInput [matAutocomplete]="auto" (change)="fieldChanged(field)" name="fieldValue_{{ field.ID }}"
								[(ngModel)]="field.FieldValue" [disabled]="readOnly" />
						</mat-form-field>

						<mat-autocomplete #auto="matAutocomplete" (optionSelected)="fieldChanged(field)">
							<mat-option *ngFor="let option of field.ListOfValues; trackBy: valuesListTrackByFn" [value]="option">
								{{ option }}
							</mat-option>
						</mat-autocomplete>
					</div>
					<div class="controlWidth" *ngIf="field.ListOfValues && field.ListOfValues.length !== 0 && field.LimitToList === true">
						<select name="fieldValue_{{ field.ID }}" class="form-control" [(ngModel)]="field.FieldValue" (change)="fieldChanged(field)"
							[disabled]="readOnly">
							<option *ngFor="let option of field.ListOfValues; trackBy: valuesListTrackByFn">{{ option }}</option>
						</select>
					</div>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="DeleteColumn">
				<mat-header-cell *matHeaderCellDef>
					label for col3
				</mat-header-cell>
				<mat-cell *matCellDef="let field">
					<div class="controlColumn" *ngIf="!readOnly && field.FieldValue">
						<button type="button" mat-icon-button color="warn" class="bs-button" title="Clear Value" (click)="clearField(field)">
							<mat-icon>delete</mat-icon>
						</button>
					</div>
				</mat-cell>
			</ng-container>
			<mat-header-row *matHeaderRowDef="[]" style="display: none;"></mat-header-row>
			<mat-row *matRowDef="let field; columns: ['FieldName', 'EditColumn', 'DeleteColumn']; index as index"> </mat-row>
		</mat-table>
	</div>
</div>
<div class="row" *ngFor="let error of errors; trackByItem">
	<div>
		<div style="text-align: center;" class="error">{{ error }} Errors</div>
	</div>
</div>
<div class="row" [hidden]="!isDirty || readOnly">
	<div class="grid-container" *ngIf="!mustReload">
		<div style="text-align: right;">
			<button style="width: 130px;" class="btn btn-cancelSave" (click)="cancelChanges()">CANCEL CHANGES</button>
		</div>
		<div></div>
		<div style="text-align: left;">
			<button style="width: 130px;" class="btn btn-save" (click)="save()">SAVE CHANGES</button>
		</div>
	</div>
	<div *ngIf="mustReload === true">
		<div>
			<button class="btn btn-error" (click)="loadLocalUse()">RELOAD</button>
		</div>
	</div>
</div>
